import { useTheme } from "next-themes"
import { Toaster as Sonner, type ToasterProps } from "sonner"

// No `richColors`: it paints success green and error red-filled, the only
// saturated surfaces in a one-accent system.
function Toaster(props: ToasterProps) {
  const { resolvedTheme } = useTheme()
  return (
    <Sonner
      theme={resolvedTheme === "light" ? "light" : "dark"}
      position="bottom-right"
      duration={4000}
      gap={8}
      visibleToasts={3}
      toastOptions={{
        classNames: {
          toast:
            "!rounded-lg !border !border-border !bg-popover !text-popover-foreground !shadow-popover !text-sm !font-sans",
          description: "!text-muted-foreground",
        },
      }}
      {...props}
    />
  )
}

export { Toaster }
